var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var applicationUtils = require('./../applicationUtils');
var launcherAppInterface = require('./../launcherApplicationInterface');

var appointmentExtService = require('./../urls').appointmentExtService;
var appointmentInstructionItemTemplate = require('./appointmentInstructionItemTemplate.hbs');
var appointmentConfigurationModel = require('./../appointment-config/appointmentConfigurationModel.js');
var LocationDataBehavior = require('./../location/LocationDataBehavior');
var AppointmentTypeParentBehavior = require('./../behaviors/AppointmentTypeParentBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var specificAppointmentFeatureConfigCollection = require('./specificAppointmentFeatureConfigCollection');

/**
 * This view renders a single appointment instruction item
 * @class AppointmentInstructionItemView
 * @constructor
 * @extends Torso.View
 */
module.exports = TorsoView.extend({
  tagName: 'li',
  className: 'brec-list__item brec-list__item--top-border',
  template: appointmentInstructionItemTemplate,

  behaviors: {
    location: {
      behavior: LocationDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: {property: 'model:externalAppointment.locationCode'}
    },
    appointmentTypeParentBehavior: AppointmentTypeParentBehavior,
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: {property: 'model:externalAppointment.type'}
    },
    parentAppointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: {property: 'behaviors.appointmentType.data:parentExternalId'}
    },
    grandparentAppointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: {property: 'behaviors.parentAppointmentType.data:parentExternalId'}
    }
  },

  prepareFields: {
    isAtHospital: function() {
      return launcherAppInterface.isAtHospital();
    },
    instructions: function() {
      var appointmentTypeModel = this.getBehavior('appointmentType').data.getModel();
      if (appointmentTypeModel) {
        return appointmentTypeModel.getEffectiveInstructions();
      }
      return null;
    },
    appointmentTimeReplacement: function() {
      var appointmentTypeModel = this.getBehavior('appointmentType').data.getModel();
      if (appointmentTypeModel) {
        return appointmentTypeModel.getEffectiveAppointmentTimeReplacement();
      }
      return null;
    },
    displayName: function() {
      var appointmentTypeModel = this.getBehavior('appointmentType').data.getModel();
      if (appointmentTypeModel) {
        return appointmentTypeModel.get('displayName');
      } else {
        return this.model.get('externalAppointment.type');
      }
    },
    patientVecnaId: '_patientVecnaId',
    currentApplication: function() {
      return applicationUtils.currentApplication;
    },
    removeAppointmentTimeDisplay: function() {
      if (appointmentConfigurationModel.isLoading() || !appointmentConfigurationModel.hasLoadedOnce()) {
        return false;
      }
      return appointmentConfigurationModel.get('removeAppointmentTimeDisplay');
    }
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function(options) {
    TorsoView.prototype.initialize.apply(this);
    _.bindAll(this, 'render', '_setAppointmentConfigsToBarcodeState');
    this._patientVecnaId = options.context.patientVecnaId;
    this._barcodeState = options.context.barcodeState;
    this.listenTo(appointmentConfigurationModel, 'load-complete', this.render);
    appointmentConfigurationModel.loadOnce();

    specificAppointmentFeatureConfigCollection
        .fetchByCriteria(this.model.toJSON())
        .done(this._setAppointmentConfigsToBarcodeState);
  },

  /**
   * Sets details of the specific appointment config to view
   * @method _setAppointmentConfigsToBarcodeState
   * @param appointmentConfig {Object} config of this specific appointment
   * @private
   */
  _setAppointmentConfigsToBarcodeState: function(appointmentConfig) {
    var preventBarcode = appointmentConfig.get('configLevels.NORMAL.preRegistration.preventBarcode');
    if (preventBarcode === false) {
      this._barcodeState.set('barcodeAllowed', true);
      var appointmentExternalId = this.model.get('externalId');
      var barcodeUrl = appointmentExtService + '/' + appointmentExternalId + '/barcode?orientation=90';
      this._barcodeState.set('barcodeUrl', barcodeUrl);
    }
  }
});
